import React from "react";

const PieChartSkeleton = () => {
    return (
        <div className="flex flex-row items-center justify-center gap-5 h-[200px]">
            <div className="w-[150px] h-[150px] rounded-full bg-gray-300 animate-pulse"></div>

            <div className="space-y-2 animate-pulse">
                {[...Array(5)].map((_, i) => (
                    <div key={i} className="flex justify-between items-center space-x-4">
                        <div className="h-4 w-28 bg-gray-300 rounded"></div>
                        <div className="h-4 w-6 bg-gray-300 rounded"></div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PieChartSkeleton;